import React from 'react';
import { focusRing } from '@shared/utils/statusTone';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export const Input: React.FC<InputProps> = ({ label, error, className = '', id, ...props }) => {
  // Associate the label with the control: a bare <label> next to an <input> is not a
  // programmatic association, so assistive tech (and `label[for]`) never sees the name.
  const generatedId = React.useId().replace(/:/g, '');
  const inputId = id ?? `app-input-${generatedId}`;
  const errorId = error ? `${inputId}-error` : undefined;

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className="app-field-label">
          {label}
        </label>
      )}
      <input
        id={inputId}
        aria-invalid={error ? true : undefined}
        aria-describedby={errorId}
        className={`
          app-field-control w-full
          ${focusRing}
          ${
            error
              ? 'border-2 border-state-danger-light dark:border-state-danger-dark focus:border-state-danger-light dark:focus:border-state-danger-dark'
              : ''
          }
          ${className}
        `}
        {...props}
      />
      {error && (
        <p
          id={errorId}
          className="mt-1.5 text-xs font-bold text-state-danger-light dark:text-state-danger-dark ml-1"
        >
          {error}
        </p>
      )}
    </div>
  );
};
